import { DEFAULT_COUNTDOWN_TIME, REDIRECT_TO_STATUS } from 'config/config';
import { circleProgressAnimation, styles } from 'consts';
import styled from 'styled-components';

const { fontMontserrat, white, primaryBlack, bluePrimary, grayPrimary } = styles;

const loadingAnimation = `circleProgressAnimation ${DEFAULT_COUNTDOWN_TIME}ms linear`;

const getStrokeDashoffset = ({ strokeDashoffset }: { strokeDashoffset: number }) => strokeDashoffset;

const PendingScreenContainer = styled.div`
  border-radius: 0.5rem;
  background: ${white};
  text-align: center;
  color: ${primaryBlack};
  padding: 3.3125rem;

  @media (max-width: 768px) {
    max-width: 14.125rem;
    margin-left: auto;
    margin-right: auto;
  }
`;

const ProgressRingSvg = styled.svg.attrs({
  height: 90,
  width: 120,
})`
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
`;

const PendingScreenSpinner = styled.div`
  position: relative;
  height: 5.625rem;
  margin-top: 6.25rem;
`;

const PendingScreenText = styled.div`
  font-family: ${fontMontserrat};
  font-size: 1rem;
  font-weight: bold;
  color: ${primaryBlack};
  line-height: 1.5;
  max-width: 20rem;
  margin: 0 auto;
  margin-bottom: 6.25rem;
`;

const ProgressRing = styled.circle.attrs({
  cx: 60,
  cy: 45,
  r: 26,
})`
  transition: 0.35s stroke-dashoffset;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  stroke-dasharray: 326 326;
  stroke-width: 4;
  fill: transparent;
`;

const ProgressRingCircle = styled(ProgressRing)`
  animation: ${loadingAnimation};
  stroke: ${bluePrimary};
  ${circleProgressAnimation};
`;

const ProgressRingPlaceholder = styled(ProgressRing)`
  stroke: ${grayPrimary};
`;

const FastRedirectProgressRing = styled(ProgressRing)<{ strokeDashoffset: number }>`
  @keyframes fastProgressAnimation {
    0% {
      stroke-dashoffset: ${getStrokeDashoffset};
    }
    100% {
      stroke-dashoffset: 163;
    }
  }

  stroke-dashoffset: 163;
  animation: fastProgressAnimation ${REDIRECT_TO_STATUS}ms linear;
  stroke: ${bluePrimary};
`;

export {
  PendingScreenContainer,
  ProgressRingSvg,
  PendingScreenSpinner,
  PendingScreenText,
  ProgressRingCircle,
  ProgressRingPlaceholder,
  FastRedirectProgressRing,
};
